import { createFileRoute } from "@tanstack/react-router"
import { WidgetWeb } from "modules/campaigns/components/Sections/triggers/widget"
import { z } from "zod"

const SearchSchema = z.object({ from: z.string().optional() })

export const Route = createFileRoute("/_base/_auth/settings/channels/widget/")({
  component: WidgetWeb,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => {
    return SearchSchema.parse(search)
  },
})
